"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = exports.ErrorBoundaryHandlerProvider = void 0;
const React = __importStar(require("react"));
const ErrorBoundaryHandler = React.createContext({
    renderError: props => React.createElement("div", null,
        "Error: ",
        props.error.stack),
});
/** This allows for customisation of the error boundary display for extension points */
const ErrorBoundaryHandlerProvider = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(ErrorBoundaryHandler.Provider, { value: props, children: children }));
};
exports.ErrorBoundaryHandlerProvider = ErrorBoundaryHandlerProvider;
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
        };
    }
    componentDidCatch(error, info) {
        // Display fallback UI
        this.setState({ hasError: true, error: error, info: info });
        // You can also log the error to an error reporting service
        //logErrorToMyService(error, info);
    }
    render() {
        const { hasError, error, info } = this.state;
        if (hasError) {
            // You can render any custom fallback UI
            //return <h1>Something went wrong.</h1>;
            return (React.createElement(ErrorBoundaryHandler.Consumer, null, ({ renderError: Exception }) => React.createElement(Exception, { error: error, info: info })));
        }
        return this.props.children;
    }
}
exports.ErrorBoundary = ErrorBoundary;
